import type { JobMetrics } from "@/types/api";

// The Health card's fleet totals (Figma 14879-250781, "EVENTS PROCESSED"
// block): the all-time counters and live throughput of every deployed
// pipeline summed into one line each. Metrics come per job
// (/jobs/{name}/metrics — the same feed the pipeline page's Metrics
// section reads); a job whose metrics haven't answered yet (or failed)
// contributes nothing rather than holding the totals back.

export interface FleetTotals {
  events: number;
  bytes: number;
  throughput: number;
}

export function aggregateJobMetrics(
  list: ReadonlyArray<JobMetrics | undefined>,
): FleetTotals {
  const totals: FleetTotals = { events: 0, bytes: 0, throughput: 0 };
  for (const m of list) {
    if (!m) continue;
    totals.events += m.events_processed;
    totals.bytes += m.bytes_processed;
    totals.throughput += m.throughput_per_second;
  }
  return totals;
}

export type HealthKind = "running" | "failed" | "stopped";

/** The Health card's stacked bar: one segment per status that has any
 *  pipelines, in the card's order, each sized by its count. */
export function healthSegments(
  counts: Record<HealthKind, number>,
): { kind: HealthKind; count: number }[] {
  return (["running", "failed", "stopped"] as const)
    .filter((kind) => counts[kind] > 0)
    .map((kind) => ({ kind, count: counts[kind] }));
}
